(function() {
  'use strict';

  class Product3DViewer {
    constructor(container, options) {
      this.container = container;
      this.productId = options.productId || '';
      this.glbUrl = options.glbUrl || '';
      this.usdzUrl = options.usdzUrl || '';
      this.posterUrl = options.posterUrl || '';
      this.dimensionsCm = options.dimensionsCm || null;
      this.modelViewerEl = null;
      this.loaded = false;
      this.init();
    }

    init() {
      if (!this.supportsWebGL()) { this.renderFallback(); return; }
      this.ensureModelViewerLoaded().then(() => this.render());
    }

    supportsWebGL() {
      try {
        var c = document.createElement('canvas');
        return !!(c.getContext('webgl') || c.getContext('webgl2'));
      } catch (e) { return false; }
    }

    ensureModelViewerLoaded() {
      return new Promise(function(resolve) {
        if (customElements.get('model-viewer')) { resolve(); return; }
        var script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
        script.onload = function() { resolve(); };
        script.onerror = function() { resolve(); }; // graceful degradation
        document.head.appendChild(script);
      });
    }

    render() {
      var mv = document.createElement('model-viewer');
      mv.setAttribute('src', this.glbUrl);
      if (this.usdzUrl) mv.setAttribute('ios-src', this.usdzUrl);
      mv.setAttribute('alt', 'Interactive 3D product view');
      mv.setAttribute('auto-rotate', '');
      mv.setAttribute('camera-controls', '');
      mv.setAttribute('touch-action', 'pan-y');
      mv.setAttribute('ar', '');
      mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
      mv.setAttribute('shadow-intensity', '1');
      mv.setAttribute('environment-image', 'neutral');
      if (this.posterUrl) mv.setAttribute('poster', this.posterUrl);
      mv.style.width = '100%';
      mv.style.height = '400px';
      mv.style.backgroundColor = '#f5f5f5';
      mv.style.borderRadius = '12px';

      // AR button slot
      var arBtn = document.createElement('button');
      arBtn.setAttribute('slot', 'ar-button');
      arBtn.className = 'viewer-ar-btn';
      arBtn.textContent = 'View in Your Room';
      mv.appendChild(arBtn);

      this.container.innerHTML = '';
      this.container.appendChild(mv);
      this.modelViewerEl = mv;

      var self = this;
      mv.addEventListener('load', function() {
        self.loaded = true;
        self.container.dispatchEvent(new CustomEvent('3d-loaded', { detail: { productId: self.productId } }));
      });
      mv.addEventListener('ar-status', function(e) {
        self.container.dispatchEvent(new CustomEvent('ar-status', { detail: e.detail }));
      });
    }

    renderFallback() {
      this.container.innerHTML = '<div class="viewer-fallback">' +
        (this.posterUrl ? '<img src="' + this.posterUrl + '" alt="Product">' : '') +
        '<p>3D viewing requires a WebGL-capable browser.</p></div>';
    }

    updateModel(glbUrl, usdzUrl, posterUrl) {
      this.glbUrl = glbUrl || this.glbUrl;
      this.usdzUrl = usdzUrl || this.usdzUrl;
      this.posterUrl = posterUrl || this.posterUrl;
      if (this.modelViewerEl) {
        this.modelViewerEl.setAttribute('src', this.glbUrl);
        if (this.usdzUrl) this.modelViewerEl.setAttribute('ios-src', this.usdzUrl);
        if (this.posterUrl) this.modelViewerEl.setAttribute('poster', this.posterUrl);
      }
    }

    rotateLeft() { this.rotate(-45); }
    rotateRight() { this.rotate(45); }
    rotate(degrees) {
      if (!this.modelViewerEl) return;
      var orbit = this.modelViewerEl.getCameraOrbit();
      orbit.theta += degrees * Math.PI / 180;
      this.modelViewerEl.cameraOrbit = orbit.toString();
    }
    resetView() {
      if (this.modelViewerEl) this.modelViewerEl.cameraOrbit = 'auto auto auto';
    }
    activateAR() {
      if (this.modelViewerEl) this.modelViewerEl.activateAR();
    }
    getDimensions() { return this.dimensionsCm; }
  }

  window.Product3DViewer = Product3DViewer;
})();
